export const displayedData = {
    single: {
        users: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.users_up_to_1',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.users_count_notice.single'
        },
        social_profiles: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count_notice.not_manual_plan_notice'
        },
        data_retention: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.data_retention',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.data_retention_notice.single'
        }
    },
    teams: {
        users: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.users_up_to_other',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.users_count_notice.teams'
        },
        social_profiles: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count_notice.not_manual_plan_notice'
        },
        data_retention: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.data_retention',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.data_retention_notice.teams'
        }
    },
    custom: {
        users: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.users_up_to_other',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.users_count_notice.custom'
        },
        social_profiles: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.social_profiles_count_notice.manual_plan_notice'
        },
        data_retention: {
            title: 'settings:subscription_invoices_page.new_pricing.plan_description.data_retention_unlimited',
            description:
                'settings:subscription_invoices_page.new_pricing.plan_description.data_retention_notice.custom'
        }
    }
} as const;

export const textStyle = {
    single: 'text-icoPink',
    teams: 'text-icoOrange',
    custom: 'text-icoBlue'
} as const;

export function getDataRetention(variant: keyof typeof displayedData) {
    if (variant === 'single') {
        return 12;
    }
    if (variant === 'teams') {
        return 24;
    }

    return null;
}
